import React from "react";
import { Row, Col, Alert, Form, Card, Button } from "react-bootstrap";
import { IoDocumentTextOutline, IoDocumentAttachOutline } from "react-icons/io5"
import { BsShieldCheck, BsCashStack } from "react-icons/bs";
import _dropzone from "../../../componets/_dropzone";
import apiEndPoints from "../../../componets/json/apiEndPoints.json";
class _renderDeviceInfo extends React.Component {
    state = {
        calendar: []
    }

    getCalendarDay = async (e) => {
        const _res = await this.props._api({
            ...this.props,
            method: "get",
            endpoint: apiEndPoints.britex.Date.Calendar.replace("{year}", this.props.warranty.datePurch.year).replace("{month}", e),
            param: "",
        });
        if (_res.status == 200) {
            this.setState({ calendar: _res.data });
        }
    }

    render() {
        return (
            <>
                <Row className="mb-2">
                    <Col>
                        <h6><strong>Typ opravy</strong></h6>
                    </Col>
                </Row>
                {this.props.warranty.alert.show && (
                    <Row className="mb-2">
                        <Col>
                            <Alert variant={this.props.warranty.alert.variant}>
                                {this.props.warranty.alert.text}
                            </Alert>
                        </Col>
                    </Row>
                )}
                {this.props.warranty.set && (
                    <>
                        {this.props.warranty.type == 1 && (
                            <Card className="mt-4 mb-4" bg="uni">
                                <Card.Body>
                                    <Row className="d-flex justify-content-between">
                                        <Col className="d-flex justify-content-between">
                                            <span>
                                                <BsShieldCheck className="fs-20 me-2" />
                                                <strong>Záruční</strong>
                                            </span>
                                            <span><small className="text-muted">Datum prodeje: </small>{this.props.warranty.datePurch?.day + "." + this.props.warranty.datePurch?.month + "." + this.props.warranty.datePurch?.year}</span>
                                            <span>
                                                <IoDocumentAttachOutline className="fs-20 me-2" />
                                                <strong>Doložen</strong>
                                            </span>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        )}

                        {this.props.warranty.type == 2 && (
                            <Card className="mt-4 mb-4" bg="uni">
                                <Card.Body>
                                    <Row className="d-flex justify-content-between">
                                        <Col className="d-flex justify-content-between">
                                            <span>
                                                <BsCashStack className="fs-20 me-2" />
                                                <strong>Nezáruční</strong>
                                            </span>
                                            <span><small className="text-muted">Předběžne schválená cena: </small>{this.props.warranty.priceAccept}</span>
                                            <span>
                                                <IoDocumentAttachOutline className="fs-20 me-2" />
                                                <strong>Doložen</strong>
                                            </span>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        )}


                    </>
                )}
                {!this.props.warranty.set && (
                    <>
                        <Row className="mb-2">
                            <Col>
                                <Card bg="uni">
                                    <Row className="mt-3 mb-3 ms-3 me-3">
                                        <Col xs={12} className="align-items-center">
                                            <Row>
                                                <Col xs={1} className="d-flex justify-content-center align-items-center">
                                                    <IoDocumentTextOutline className="fs-20" />
                                                </Col>
                                                <Col xs={11}>
                                                    <Row>
                                                        <Col xs={6}>
                                                            <Form.Select onChange={(e) => this.props.setState({ warranty: { ...this.props.warranty, type: e.target.value } })}>
                                                                <option value="-1">Druh opravy</option>
                                                                <option value="1">Záruční</option>
                                                                <option value="2">Nezáruční</option>
                                                            </Form.Select>
                                                            <Form.Text>Druh</Form.Text>
                                                        </Col>
                                                        {this.props.warranty.type == 2 && (
                                                            <Col xs={6}>
                                                                <Form.Control onChange={(e) => this.props.setState({ warranty: { ...this.props.warranty, priceAccept: e.target.value } })} min="450.0" type="number" step="0.1" />
                                                                <Form.Text>Předběžně schválená cena opravy</Form.Text>0
                                                            </Col>
                                                        )}
                                                        {this.props.warranty.type == 1 && (
                                                            <>
                                                                <Col xs={2} className="mb-4">
                                                                    <Form.Select value={this.props.warranty.datePurch?.year} onChange={(e) => this.props.setState({ warranty: { ...this.props.warranty, datePurch: { ...this.props.warranty.datePurch, year: e.target.value } } })}>
                                                                        <option value={""}>{""}</option>
                                                                        <option value={(new Date().getFullYear() - 3)}>{(new Date().getFullYear() - 3)}</option>
                                                                        <option value={new Date().getFullYear() - 2}>{new Date().getFullYear() - 2}</option>
                                                                        <option value={new Date().getFullYear() - 1}>{new Date().getFullYear() - 1}</option>
                                                                        <option value={new Date().getFullYear()}>{new Date().getFullYear()}</option>
                                                                    </Form.Select>
                                                                    <Form.Text>Rok prodeje</Form.Text>
                                                                </Col>
                                                                <Col xs={2} className="mb-4">
                                                                    <Form.Select value={this.props.warranty.datePurch?.month} disabled={!this.props.warranty.datePurch?.year} onChange={(e) => { this.props.setState({ warranty: { ...this.props.warranty, datePurch: { ...this.props.warranty.datePurch, month: e.target.value } } }); this.getCalendarDay(e.target.value) }}>
                                                                        <option value={""}>{""}</option>
                                                                        <option value={1}>{1}</option>
                                                                        <option value={2}>{2}</option>
                                                                        <option value={3}>{3}</option>
                                                                        <option value={4}>{4}</option>
                                                                        <option value={5}>{5}</option>
                                                                        <option value={6}>{6}</option>
                                                                        <option value={7}>{7}</option>
                                                                        <option value={8}>{8}</option>
                                                                        <option value={9}>{9}</option>
                                                                        <option value={10}>{10}</option>
                                                                        <option value={11}>{11}</option>
                                                                        <option value={12}>{12}</option>
                                                                    </Form.Select>
                                                                    <Form.Text>Měsíc prodeje</Form.Text>
                                                                </Col>
                                                                <Col xs={2} className="mb-4">
                                                                    <Form.Select value={this.props.warranty.datePurch?.day} disabled={!this.props.warranty.datePurch?.month} onChange={(e) => this.props.setState({ warranty: { ...this.props.warranty, datePurch: { ...this.props.warranty.datePurch, day: e.target.value } } })}>
                                                                        <option value={""}>{""}</option>
                                                                        {this.state.calendar.map(c => {
                                                                            return (<option value={new Date(c.date).getDate()}>{new Date(c.date).getDate()}</option>)
                                                                        })}
                                                                    </Form.Select>
                                                                    <Form.Text>Den prodeje</Form.Text>
                                                                </Col>
                                                                <Col xs={12}> 
                                                                    <Row>
                                                                        <Col xs={11} >
                                                                            <_dropzone files={this.props.warranty.files} setfiles={this.props.setFile} noUpload />
                                                                            <Form.Text>Prodejní doklad</Form.Text>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </>
                                                        )}
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={12} className="d-flex justify-content-end">
                                            <Button variant="success" size="sm" onClick={this.props.confirmWarranty}>Potvrdit</Button>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </>
                )}
            </>
        )
    }
}
export default _renderDeviceInfo;